import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { PlausibilitaetEntity } from '../../../entities/mdqx/plausibilitaet.entity';
import { HttpService } from '../../../services/http.service';
import { GetPlausibilitaetenResponse, PlausibilitaetActionTypes } from '../../actions/mdqx/plausibilitaet.actions';
import { DaveActions } from '../../actions/actions';
import { BaseActionTypes } from '../../actions/base.actions';
import { getToken } from '../../selectors/base.selectors';
import { State } from '../../index';

enum ErrorCodes {
    Get = 'Plausibilitäten Abrufen fehlgeschlagen',
}

@Injectable()
export class PlausibilitaetEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(PlausibilitaetActionTypes.GetPlausibilitaetenRequest),
        map(
            () => `
            {
                plausibilitaet {
                    ${PlausibilitaetEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }).pipe(
                map(res => res && res.plausibilitaet),
                concatMap(res =>
                    res
                        ? [
                              new GetPlausibilitaetenResponse(
                                  res.map(
                                      plausibilitaet => new PlausibilitaetEntity(plausibilitaet),
                                  ),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
